/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_StorageInputs */

const en_mk_mx_storage = /** @type {(inputs: Mk_Mx_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attachment storage`)
};

const id_mk_mx_storage = /** @type {(inputs: Mk_Mx_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyimpanan lampiran`)
};

/**
* | output |
* | --- |
* | "Attachment storage" |
*
* @param {Mk_Mx_StorageInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_storage = /** @type {((inputs?: Mk_Mx_StorageInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_StorageInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_storage(inputs)
	return en_mk_mx_storage(inputs)
});